import dayjs from 'dayjs'

export type DateRangeOption = 'all' | '1h' | '24h' | '7d'

export type VlmResultsFilterState = {
  dateRange: DateRangeOption
}

export const DEFAULT_FILTERS: VlmResultsFilterState = {
  dateRange: 'all'
}

const DATE_RANGE_HOURS: Partial<Record<DateRangeOption, number>> = {
  '1h': 1,
  '24h': 24,
  '7d': 168
}

export const getStartDate = (range: DateRangeOption) => {
  const hours = DATE_RANGE_HOURS[range]
  return hours ? dayjs().subtract(hours, 'hour').toISOString() : undefined
}
